import { Component, OnInit } from '@angular/core';
import {ManualesFaces} from '../interfaces/manualesFaces';
import {ActivatedRoute, Router } from '@angular/router';
import {HttpClient} from '@angular/common/http';
import { ModalService } from '../services/modal.service';
import {AlertsService } from 'angular-alert-module';
import {environment} from "../../environments/environment";
import Constants from "../lib/Constants";

@Component({
  selector: 'app-sintegrado',
  templateUrl: './sintegrado.component.html',
  styleUrls: ['./sintegrado.component.css']
})

export class SintegradoComponent implements OnInit {
  
  API_ENDPOINT: string = Constants.BASEURLAPI;
  constructor() { 
  }



  



    ngOnInit() {

  }

}